import { userService } from '../services';
import {
  GET_BLOG_POSTS,
  GET_BLOG_POSTS_LOADING,
  GET_BLOG_POSTS_CATEGORIES,
  GET_BLOG_POSTS_CATEGORIES_LOADING,
  GET_BLOG_POST_DETAILS_LOADING,
  GET_BLOG_POST_DETAILS,
  FAILED_BLOG_POST_DETAILS,
  GET_BLOG_RELATED_POSTS,
  GET_BLOG_RELATED_POSTS_LOADING,
  GET_BLOG_AUTHOR,
  GET_BLOG_AUTHOR_LOADING,
} from '../config/actionTypes';
export const blogActions = {
  getBlogPosts,
  getBlogPostsCategories,
  getBlogPostDetails,
  getBlogRelatedPosts,
  getBlogAuthor,
};

function getBlogPosts(page_index = 1, categoryId, page_size = 9) {
  let params = `?page_index=${page_index}&page_size=${page_size}`;
  if (categoryId) params += `&category_id=${categoryId}`;
  return (dispatch) => {
    dispatch(blogPostsLoading());
    userService.GetInfo('/blogs/posts', params).then((blogPosts) => {
      dispatch(success(blogPosts.response));
    });
  };
  function blogPostsLoading() {
    return { type: GET_BLOG_POSTS_LOADING, loading: true };
  }
  function success(blogPosts) {
    return { type: GET_BLOG_POSTS, blogPosts, loading: false };
  }
}

function getBlogPostsCategories() {
  return (dispatch) => {
    dispatch(blogPostsCategoriesLoading());
    userService.GetInfo('/blogs/categories', '').then((blogPostsCategories) => {
      dispatch(success(blogPostsCategories));
    });
  };
  function blogPostsCategoriesLoading() {
    return { type: GET_BLOG_POSTS_CATEGORIES_LOADING, loading: true };
  }
  function success(blogPostsCategories) {
    return { type: GET_BLOG_POSTS_CATEGORIES, blogPostsCategories, loading: false };
  }
}

function getBlogPostDetails(postId) {
  return (dispatch) => {
    dispatch(blogPostDetailsLoading());
    userService.GetInfo(`/blogs/post/${postId}`, '').then(
      (blogPostDetails) => {
        dispatch(success(blogPostDetails));
      },
      (err) => {
        dispatch(failed(err));
      }
    );
  };
  function blogPostDetailsLoading() {
    return { type: GET_BLOG_POST_DETAILS_LOADING, loading: true };
  }
  function success(blogPostDetails) {
    return { type: GET_BLOG_POST_DETAILS, blogPostDetails, loading: false };
  }
  function failed(error) {
    return { type: FAILED_BLOG_POST_DETAILS, error };
  }
}

function getBlogRelatedPosts(categoryId, currentPostId) {
  return (dispatch) => {
    dispatch(loading());
    userService.GetInfo('/blogs/posts', `?page_index=1&page_size=6&category_id=${categoryId}`).then((data) => {
      const list = data?.response?.list || [];
      const filtered = list.filter((post) => post.id !== currentPostId).slice(0, 5);
      dispatch(success(filtered));
    });
  };
  function loading() {
    return { type: GET_BLOG_RELATED_POSTS_LOADING };
  }
  function success(posts) {
    return { type: GET_BLOG_RELATED_POSTS, posts };
  }
}

function getBlogAuthor(authorId) {
  return (dispatch) => {
    dispatch(loading());
    userService.GetInfo(`/blogs/authors/${authorId}`, '').then((author) => {
      dispatch(success(author));
    });
  };
  function loading() {
    return { type: GET_BLOG_AUTHOR_LOADING };
  }
  function success(author) {
    return { type: GET_BLOG_AUTHOR, author };
  }
}
